import styles from './styles.module.css'
export const Placeholder = ({
  children,
  externalClasses = '',
}: {
  children: any
  externalClasses?: string
}): JSX.Element => <span className={`${styles.Placeholder} ${externalClasses}`}>{children}</span>
